var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "slider-section-desktop"
  }, [_c('div', {
    staticClass: "slider-section"
  }, [_c('about-us-arrow2', {
    attrs: {
      "title": _vm.fields.sections.value.section_one
    }
  }), _c('div', {
    staticClass: "slider-boxes"
  }, [_vm._l(_vm.fields.shareholders.value.boxes, function (box, index) {
    return _c('div', {
      staticClass: "slide-box lead-1",
      class: {
        last: _vm.fields.shareholders.value.boxes.length - 1 === index
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(box.text)
      }
    }), _c('div', {
      staticClass: "branch-down"
    })]);
  }), _c('div', {
    staticClass: "slide-section-divider",
    style: {
      '--num-boxes': _vm.fields.shareholders.value.boxes.length
    }
  })], 2)], 1), _c('div', {
    staticClass: "slider-section"
  }, [_c('about-us-arrow2', {
    attrs: {
      "title": _vm.fields.sections.value.section_two,
      "is-primary": ""
    }
  }), _c('div', {
    staticClass: "slider-boxes"
  }, [_c('div', {
    staticClass: "slider-boxes"
  }, [_c('div', {
    staticClass: "slide-box lead-1"
  }, [_c('seu-logo-expanded'), _c('div', {
    staticClass: "branch-down"
  }), _c('div', {
    staticClass: "branch-up"
  })], 1)])])], 1), _vm._l(_vm.partnersDesktop, function (section, index) {
    return _c('div', {
      staticClass: "slider-section"
    }, [_c('about-us-arrow2', {
      attrs: {
        "is-hidden": index > 0,
        "title": _vm.fields.sections.value.section_three
      }
    }), _c('div', {
      staticClass: "slider-boxes"
    }, [_vm._l(section, function (box, index) {
      return _c('div', {
        staticClass: "slide-box lead-1",
        class: {
          last: section.length - 1 === index
        }
      }, [box.image ? _c('a', {
        attrs: {
          "target": "_blank",
          "href": box.url
        }
      }, [_c('img', {
        attrs: {
          "src": box.image
        }
      })]) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(box.text)
        }
      }), _c('div', {
        staticClass: "branch-up"
      })]);
    }), _c('div', {
      staticClass: "slide-section-divider four dir-above"
    }), index < _vm.partnersDesktop.length - 1 ? _c('div', {
      staticClass: "slide-section-vertical-divider"
    }) : _vm._e()], 2)], 1);
  })], 2), _c('div', {
    staticClass: "slider-section-mobile"
  }, [_c('div', {
    staticClass: "slider-section"
  }, [_c('div', {
    staticClass: "section-title lead-1-large"
  }, [_vm._v(" Aktionariat ")]), _c('div', {
    staticClass: "slider-boxes"
  }, [_c('div', {
    staticClass: "slide-box lead-1",
    staticStyle: {
      "padding": "48px 32px"
    }
  }, [_vm._l(_vm.fields.shareholders.value.boxes, function (box, index) {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(box.text)
      }
    }), index < _vm.fields.shareholders.value.boxes.length - 1 ? _c('div', {
      staticClass: "slide-box-divider"
    }) : _vm._e()];
  }), _c('div', {
    staticClass: "branch-down"
  })], 2)])]), _c('div', {
    staticClass: "slider-section"
  }, [_vm._m(0), _c('div', {
    staticClass: "slider-boxes"
  }, [_c('div', {
    staticClass: "slide-box lead-1",
    staticStyle: {
      "padding": "64px 40px"
    }
  }, [_c('seu-logo-expanded'), _c('div', {
    staticClass: "branch-down"
  })], 1)])]), _c('div', {
    staticClass: "slider-section"
  }, [_c('div', {
    staticClass: "section-title lead-1-large"
  }, [_vm._v(" " + _vm._s(_vm.fields.sections.value.section_three) + " "), _c('div', {
    staticClass: "branch-up"
  }), _c('div', {
    staticClass: "branch-down"
  })])]), _vm._l(_vm.partnersMobile, function (section, index) {
    return _c('div', {
      staticClass: "slider-section"
    }, [_c('div', {
      staticClass: "slider-boxes"
    }, [_vm._l(section, function (box, index) {
      return _c('div', {
        staticClass: "slide-box lead-1",
        class: {
          last: section.length - 1 === index
        },
        style: {
          aspectRatio: '1/1'
        }
      }, [box.image ? _c('img', {
        attrs: {
          "src": box.image
        }
      }) : _c('span', {
        staticClass: "box-content",
        domProps: {
          "innerHTML": _vm._s(box.text)
        }
      }), _c('div', {
        staticClass: "branch-up"
      })]);
    }), _c('div', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport",
        value: {
          transition: 'section-divider',
          duration: 1
        },
        expression: "{transition: 'section-divider', duration: 1}"
      }],
      staticClass: "slide-section-divider dir-above",
      style: {
        '--num-boxes': 2
      }
    }), index < _vm.partnersMobile.length - 1 ? _c('div', {
      staticClass: "slide-section-vertical-divider"
    }) : _vm._e()], 2)]);
  })], 2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title primary lead-1-large"
  }, [_vm._v(" SEU-Holding "), _c('div', {
    staticClass: "branch-up"
  })]);

}]

export { render, staticRenderFns }